import { BranchesDown, EllipsisVertical, ListCheck, Person, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Sheet } from '@gravity-ui/uikit';
import { useState } from 'react';

import styles from './styles.module.scss';

export const AccountListMenu = ({ setActiveComponent }: any) => {
	const [visible, setVisible] = useState(false);

	return (
		<>
			<Button view="flat" onClick={() => setVisible(true)}>
				<Icon size={20} data={EllipsisVertical} />
			</Button>
			<Sheet visible={visible} onClose={() => setVisible(false)} title="Меню бланка" className={styles.sheet}>
				<div className={styles.sheet__close}>
					<Button onClick={() => setVisible(false)} view="flat">
						<Icon data={Xmark} size={16} />
					</Button>
				</div>
				<div className={styles.sheet__btns}>
					<Button
						size="xl"
						view="flat"
						onClick={() => {
							setActiveComponent('accounts');
							setVisible(false);
						}}
					>
						<Icon size={16} data={Person} />
						Список аккаунтов
					</Button>
					<Button
						size="xl"
						view="flat"
						onClick={() => {
							setActiveComponent('establishments');
							setVisible(false);
						}}
					>
						<Icon size={16} data={ListCheck} />
						Список учреждений
					</Button>
					<Button
						size="xl"
						view="flat"
						onClick={() => {
							setActiveComponent('sections');
							setVisible(false);
						}}
					>
						<Icon size={16} data={BranchesDown} />
						Разделы и подразделы
					</Button>
				</div>
			</Sheet>
		</>
	);
};
